import { de } from "./de";

// Future: import { it } from "./it"; etc.
const dictionaries = { de };
const DEFAULT_LANG = "de";

export function getLang() {
  return localStorage.getItem("sonara_lang") || DEFAULT_LANG;
}

export function setLang(lang) {
  localStorage.setItem("sonara_lang", lang);
}

export function t(path) {
  const lang = getLang();
  const dict = dictionaries[lang] || dictionaries[DEFAULT_LANG];
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : null), dict) ?? path;
}

export default t;
